import Header from '../../components/pageHeader'
import config from './config'
import axios from 'axios'
import baseconfig from '../../../../variables/config'
import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { fetchClasses } from '../../../../modules/classes'
import { sendRequest } from '../../../../modules/admin'
import Toolbar from './toolbar'
import Popup from './popup'
import S3 from 'react-aws-s3'
import Dropzone from 'react-dropzone'

import './classes.scss'

const isStaffUser = () => {
  try {
    const { role } = JSON.parse(window.localStorage.getItem('userData'))
    return role === 'staff'
  } catch {
    return false
  }
}

const Inventory = () => {
  const [unauthorised] = useState(isStaffUser)
  const [tab, setTab] = useState(0)
  const [tabs, setTabs] = useState([])

  const [items, setItems] = useState([])
  const [themes, setThemes] = useState([])
  const [updates, setUpdates] = useState([])
  const [types, setTypes] = useState({})
  const [showable, setShowable] = useState([])
  const [popupData, setPopupData] = useState(null)
  const [isPopupOpen, setPopupOpen] = useState(false)

  const [filterData, setFilterData] = useState({
    branch: 'Redhill',
    model: 'Items + Themes',
    type: '(all)',
    subType: '(all)',
    searchText: ''
  })
  const [token] = useState(
    JSON.parse(window.localStorage.getItem('userData')).token
  )
  const [urlDetails] = useState({
    baseUrl: baseconfig.serverURL + '/InventoryItems',
    tokenStr:
      '?access_token=' +
      JSON.parse(window.localStorage.getItem('userData')).token
  })

  useEffect(() => {
    if (unauthorised) return
    fetchItems()
    fetchThemes()
    fetchUpdates()
  }, [])

  useEffect(() => {
    const { model, type, subType, searchText } = filterData
    const branch = filterData.branch.toLowerCase()

    let toShow

    switch (model) {
      case 'Items':
        toShow = [...items]
        break
      case 'Themes':
        toShow = [...themes]
        break
      case 'Updates':
        toShow = [...updates]
        break
      default:
        toShow = [...items, ...themes]
    }

    console.log({ toShow })

    if (model === 'Updates') {
      setShowable(
        toShow
          .filter(_u => hasBranchData(_u, branch))
          .map(_u => {
            _u.amount = _u.amount[branch]
            return _u
          })
      )
    } else {
      toShow.sort((a, b) => a.name.localeCompare(b.name))

      if (type !== '(all)') {
        toShow = toShow.filter(item => item.type === type)
        if (subType !== '(all)') {
          toShow = toShow.filter(item => item.subType === subType)
        }
      }

      if (searchText !== '') {
        toShow = toShow.filter(item =>
          item.name.toLowerCase().match(searchText.toLowerCase())
        )
      }

      setShowable(
        toShow.map(item => {
          const { inputValue, calcValue } = item.amount[branch]
          return {
            ...item,
            inputValue,
            calcValue
          }
        })
      )
    }
  }, [filterData])

  const _url = (model = 'InventoryItems', id = null) => {
    if (!model) model = 'InventoryItems'
    let str = baseconfig.serverURL + '/' + model
    if (id) str += '/' + id
    return str + '?access_token=' + token
  }

  const fetchItems = (rerender = true) => {
    const { baseUrl, tokenStr } = urlDetails
    axios
      .get(_url())
      .then(res => {
        console.log({ kirbyData: res })
        setItems([...res.data])
        if (rerender)
          setFilters({
            type: '(all)'
          })
        generateTypes(res.data)
      })
      .catch(err => console.log({ err }))
  }

  const fetchThemes = (rerender = true) => {
    const { baseUrl, tokenStr } = urlDetails
    axios
      .get(_url('InventoryThemes'))
      .then(res => {
        console.log({ kirbyThemes: res })
        setThemes([...res.data])
        if (rerender)
          setFilters({
            type: '(all)'
          })
        generateTypes(res.data)
      })
      .catch(err => console.log({ err }))
  }

  const fetchUpdates = (rerender = true) => {
    axios
      .get(_url('InventoryUpdates'))
      .then(res => {
        console.log({ __updates: res })
        setUpdates([...res.data])
        if (rerender)
          setFilters({
            type: '(all)'
          })
      })
      .catch(err => console.log({ err }))
  }

  const setFilters = filters => {
    setFilterData({ ...filterData, ...filters })
  }

  const getItem = id => {
    return [...items, ...themes].find(item => item.id === id) || null
  }

  const addDummy = howMany => {
    const arr = []

    for (let i = 0; i < howMany; ++i) {
      const dummy = {
        id: 'dadface',
        name: 'Dummy:' + i,
        type: ['Cup', 'Napkin', 'Balloon'][i % 3],
        amount: {
          redhill: { calcValue: 10, inputValue: 10 },
          kingston: { calcValue: 15, inputValue: 15 }
        }
      }
      arr.push(dummy)
    }

    return arr
  }

  //---Toolbar functions---

  const generateTypes = _items => {
    const types = {}
    _items.forEach(({ type, subType }) => {
      if (!types[type]) types[type] = ['(all)']
      if (subType && !types[type].find(sT => sT === subType))
        types[type].push(subType)
    })

    console.log({ types })
    setTypes(types)
  }

  const getToolbarData = () => {
    const data = [
      {
        name: 'Branch: ' + filterData.branch,
        options: config.locations,
        func: branch => setFilters({ branch }),
        selected: filterData.branch
      },
      {
        name: filterData.model,
        options: ['Items + Themes', 'Items', 'Themes', 'Updates'],
        func: model => setFilters({ model }),
        selected: filterData.model
      },
      {
        name: 'Item Type: ' + filterData.type,
        options: ['(all)', ...Object.keys(types)],
        func: type => setFilters({ type, subType: '(all)' }),
        selected: filterData.type
      }
    ]

    if (filterData.type !== '(all)') {
      data.push({
        name: 'Item Subtype: ' + filterData.subType,
        options: types[filterData.type],
        func: subType => setFilters({ subType }),
        selected: filterData.subType
      })
    }
    return data
  }

  //---Popup related---

  const handleEditClick = item => {
    const { id, included = null } = item

    //url stuff
    const url = included ? _url('InventoryThemes', id) : _url(null, id)

    setPopupData({
      onSubmit: data => axios.patch(url, data),
      initData: getItem(id),
      isTheme: included
    })

    setPopupOpen(true)
  }

  const setThemePopup = () => {
    setPopupData({
      onSubmit: data => axios.post(_url('InventoryThemes'), data),
      isTheme: true
    })

    setPopupOpen(true)
  }

  ///---Render functions---

  const getTableModeString = () => {
    if (filterData.model === 'Updates') {
      return 'Show Inventory Updates'
    } else {
      return 'Show Standard Inventory'
    }
  }

  const renderPopup = () => {
    //default data
    let data = {
      isOpen: isPopupOpen,
      onSubmit: data => axios.post(_url(), data),
      onClose: refresh => {
        if (refresh) {
          fetchItems()
          fetchThemes()
        }
        setPopupData(null)
        setPopupOpen(false)
      },
      branches: config.locations,
      items,
      onUpdateSubmit: data => axios.post(_url('InventoryUpdates'), data)
    }

    const props = popupData ? { ...data, ...popupData } : data
    return <Popup props={props} />
  }

  const renderHeaderRow = () => {
    const k = 'InventoryHeader:' //key prefix
    let headers = []
    if (filterData.model === 'Updates') {
      headers = config.updateHeaders
    } else {
      headers = config.headers
    }

    return (
      <thead>
        <tr>
          {headers.map((el, i) => (
            <th key={k + '' + i}>{el}</th>
          ))}
        </tr>
      </thead>
    )
  }

  const hasBranchData = (item, branch) => {
    if (!branch) branch = filterData.branch.toLowerCase()
    //For inventory update elements to make sure only those whose values have
    //changed for the current branch are selected
    return item.amount[branch] ? true : false
  }

  const renderUpdateItem = (item, keyPrefix) => {
    console.log([item])
    const { itemName, date, amount, note } = item

    return (
      <tr key={keyPrefix}>
        <td>{itemName}</td>
        <td>{new Date(date)}</td>
        <td>{amount.inputValue[0] || 'N/A'}</td>
        <td>{amount.inputValue[1] || 'N/A'}</td>
        <td>{amount.calcValue[0] || 'N/A'}</td>
        <td>{amount.calcValue[1] || 'N/A'}</td>
      </tr>
    )
  }

  const renderItem = (item, keyPrefix) => {
    if (filterData.model === 'Updates') return renderUpdateItem(item, keyPrefix)

    const { name, type, subType, inputValue, calcValue } = item

    return (
      <tr key={keyPrefix}>
        <td>{name}</td>
        <td>{type}</td>
        <td>{subType || 'N/A'}</td>
        <td>{calcValue}</td>
        <td>{inputValue}</td>
        <td>
          <button onClick={() => handleEditClick(item)}>EDIT</button>
        </td>
      </tr>
    )
  }

  const renderBody = () => {
    const k = 'InventoryItemRow:'
    return showable.map((el, i) => renderItem(el, k + '' + i))
  }

  return (
    <div className="ordersContainer">
      {unauthorised && (
        <div className="unauthorisedMessage">
          You are not authorised to view inventory. Only administrators can
          access inventory management.
        </div>
      )}
      {!unauthorised && (
        <>
      <Header
        title={config.mainTitle}
        tip={config.subHeading}
        icon={config.titleIcon}
        tabs={tabs}
        selected={tab}
      />
      {renderPopup()}
      {/* <div>{getTableModeString()}</div> */}
      <div className="inventory-toolbar">
        <Toolbar
          menus={getToolbarData()}
          searchFunc={searchText => setFilters({ searchText })}
        />
      </div>
      <div className="scroll-view">
        <table className="inventory-table">
          {renderHeaderRow()}
          <tbody>{renderBody()}</tbody>
        </table>
        {showable.length === 0 && (
          <div className="inventory-empty">No items to display</div>
        )}
      </div>
      <button onClick={() => setPopupOpen(true)}>Add New Item</button>
      <button onClick={() => setThemePopup()}>Add New Theme</button>
        </>
      )}
    </div>
  )
}

const mapStateToProps = ({ classes }) => ({
  classes: classes
})

const mapDispatchToProps = dispatch =>
  bindActionCreators({ sendRequest }, dispatch)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Inventory)
